import withEntity from '@/entity/components/with-entity';

import Vault from './vault';

export default withEntity(Vault);
